import React, { useState } from "react";
import { Code, Server, Layout, Database, GitBranch, Cloud, Lock, Cpu, Sparkles, Check } from "lucide-react";
import "./Skills.css";

const skillCategories = [
  {
    id: "languages",
    label: "Languages",
    title: "Programming Languages",
    icon: Code,
    skills: ["JavaScript", "TypeScript", "Python", "SQL"],
  },
  {
    id: "backend",
    label: "Backend",
    title: "Frameworks & Backend",
    icon: Server,
    skills: ["Node.js", "NestJS", "Express.js", "Python (Flask)", "Prisma ORM", "Socket.IO", "BullMQ", "Middleware Architecture"],
  },
  {
    id: "frontend",
    label: "Frontend",
    title: "Frontend Technologies",
    icon: Layout,
    skills: ["React.js", "TypeScript", "JavaScript", "HTML5", "CSS3", "Redux Toolkit", "React Query", "Tailwind CSS", "Bootstrap"],
  },
  {
    id: "databases",
    label: "Databases",
    title: "Databases & Caching",
    icon: Database,
    skills: ["PostgreSQL", "MySQL", "MongoDB", "SQLite", "Redis", "PostGIS", "Query Optimization", "Caching Strategies"],
  },
  {
    id: "cloud",
    label: "Cloud & DevOps",
    title: "Cloud & Deployment",
    icon: Cloud,
    skills: ["AWS (EC2, ECS, RDS, S3, CloudFront, Route53, IAM, CloudWatch)", "Docker", "Nginx", "Render", "Vercel", "Netlify", "CI/CD Pipelines"],
  },
  {
    id: "security",
    label: "Security",
    title: "Authentication & Security",
    icon: Lock,
    skills: ["JWT", "Google OAuth", "OTP Authentication", "HTTPS", "bcrypt", "Helmet.js", "Role-Based Access Control (RBAC)", "Rate Limiting"],
  },
  {
    id: "architecture",
    label: "System Design",
    title: "Architecture & System Design",
    icon: Cpu,
    skills: ["Modular Monolith Architecture", "Scalable Backend Architecture", "Queue Systems", "Event-Driven Architecture", "Distributed Systems Basics"],
  },
  {
    id: "core-concepts",
    label: "Core Concepts",
    title: "Core Concepts & Foundations",
    icon: GitBranch,
    skills: ["Object-Oriented Programming (OOP)", "Data Structures & Algorithms (DSA)", "RESTful API Development", "MVC Architecture", "Debugging", "Performance Optimization", "Git", "GitHub", "GitHub Actions"],
  },
  {
    id: "ai-tools",
    label: "AI Tools",
    title: "AI-Assisted Development Tools",
    icon: Sparkles,
    skills: ["GitHub Copilot", "Cursor AI", "ChatGPT", "Claude AI", "Prompt Engineering"],
  },
];

const Skills = () => {
  const [activeTab, setActiveTab] = useState("all");

  const displayedCategories = activeTab === "all"
    ? skillCategories
    : skillCategories.filter((c) => c.id === activeTab);

  return (
    <section id="technology" className="section section-secondary skills-section">
      <div className="container">
        
        {/* SECTION HEADER */}
        <div className="section-header">
          <div className="eyebrow">05 / Technical Depth</div>
          <h2 className="section-title">
            Technical <em>Proficiency</em>
          </h2>
          <p className="section-subtitle">
            Comprehensive breakdown of languages, backend frameworks, database engines, security standards, and infrastructure tools utilized in production.
          </p>
        </div>

        {/* CATEGORY FILTER TABS */}
        <div className="skills-filter-tabs">
          <button
            className={`filter-tab ${activeTab === "all" ? "active" : ""}`}
            onClick={() => setActiveTab("all")}
          >
            All Clusters
          </button>
          {skillCategories.map((cat) => (
            <button
              key={cat.id}
              className={`filter-tab ${activeTab === cat.id ? "active" : ""}`}
              onClick={() => setActiveTab(cat.id)}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* SKILLS CLUSTERS GRID */}
        <div className="skills-clusters-grid">
          {displayedCategories.map((cat) => {
            const Icon = cat.icon;
            return (
              <div key={cat.id} className="skill-cluster-card">
                <div className="cluster-header">
                  <div className="cluster-icon-wrap">
                    <Icon size={18} className="cluster-icon" />
                  </div>
                  <h3 className="cluster-title">{cat.title}</h3>
                </div>

                <div className="cluster-tags-list">
                  {cat.skills.map((skill, sIdx) => (
                    <div key={sIdx} className="skill-item-tag">
                      <span className="skill-dot"></span>
                      <span className="skill-name">{skill}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default Skills;
